export const article = [
  {
    articleId: 25,
    url: "no-es-posible-ver",
    category: {
      slug:"cuenta",
      name: "Mi cuenta"
    },
    title: "No es posible ver",
    content: 
      <>
        <div className="row">
          <h2>Cómo evitar que alguien use tu cuenta</h2>
          <p>Si alguien está usando tu cuenta sin permiso, haz lo siguiente para evitar que siga ocurriendo:</p>
        </div>
        <div className="rowLine">
          <h2>1. Cambia tu contraseña de Mega GO</h2>
          <p>Recomendamos utilizar una contraseña con las siguientes características:</p>
          <ul className="disc">
            <li>Que sea exclusiva de Mega GO y no se use en otros sitios web o apps.</li>
            <li>Que contenga un mínimo de 8 caracteres.</li>
            <li>Que sea una combinación de letras, números y símbolos, con mayúsculas y minúsculas.</li>
            <li>Que no se pueda adivinar fácilmente, como "contraseña", "12345" o información personal (nombre, cumpleaños, dirección).</li>
          </ul>
          <p>Un administrador de contraseñas puede ayudarte a ordenar tus contraseñas exclusivas.</p>
        </div>
        <div className="rowLine">
          <div className="accordeonContent">
            <h2>2. Solicita el cierre de sesiones de todos los dispositivos vinculados con tu cuenta.</h2>
            <p>Nota: Si ya realizaste el cambio de contraseña. Envíanos un correo a <a href="mailto: contacto@megago.cl">contacto@megago.cl</a> solicitando el cierre de sesiones y mencionando el correo que usaste para el proceso de suscripción.</p>
          </div>
        </div>
        <div>
          <div className="accordeonContent">
            <h2>3. Consulta Cómo mantener segura tu cuenta para ver más pasos de protección de tu cuenta.</h2>
            <p>Si no puedes restablecer la contraseña, o si sigues viendo actividad sospechosa en la cuenta después de seguir los pasos anteriores, comunícate con nosotros.</p>
          </div>
        </div>
      </>
  }
];